import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPushpin = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 16 16",
	width: 16,
	height: 16,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M9.3335 2.66667V6C9.3335 6.74667 9.58016 7.44 10.0002 8H6.00016C6.4335 7.42667 6.66683 6.73334 6.66683 6V2.66667H9.3335ZM11.3335 1.33334H4.66683C4.30016 1.33334 4.00016 1.63334 4.00016 2C4.00016 2.36667 4.30016 2.66667 4.66683 2.66667H5.3335V6C5.3335 7.10667 4.44016 8 3.3335 8V9.33334H7.3135V14L7.98016 14.6667L8.64683 14V9.33334H12.6668V8C11.5602 8 10.6668 7.10667 10.6668 6V2.66667H11.3335C11.7002 2.66667 12.0002 2.36667 12.0002 2C12.0002 1.63334 11.7002 1.33334 11.3335 1.33334Z",
		fill: "var(--main-color)"
	})
});
export { SvgPushpin as ReactComponent };
